import {createAction, createReducer} from 'redux-act';
import {FULFILLED} from 'redux-promise-middleware';
import {createSelector} from 'reselect';

import {getContactsPdp} from 'features/contacts/selectors/contacts/contacts';
import {fetchQuoteItemV2} from 'actions/cart/cart';

export const initialState = false;

/**
 * List of actions
 */
export const toggleSavePrescriptionApproval = createAction('TOGGLE_SAVE_PRESCRIPTION_APPROVAL');

export const resetSavePrescriptionApproval = createAction('RESET_SAVE_PRESCRIPTION_APPROVAL');

/**
 * save prescription reducer
 */
export const savePrescriptionApproval = createReducer({}, initialState)
    .on(resetSavePrescriptionApproval, () => false)
    .on(toggleSavePrescriptionApproval, (state: boolean) => !state)
    .on(`${fetchQuoteItemV2}_${FULFILLED}`, (state, {data}) =>
        Boolean(data.isAllowedForQuickOrder),
    );

/**
 * Get state from save prescription approval
 * @param {ApplicationStoreType} store - store
 * @returns {boolean} boolean
 */
export const getSavePrescriptionApproval = createSelector(
    getContactsPdp,
    contactLenses => contactLenses.savePrescriptionApproval,
);
